import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createStackNavigator } from "@react-navigation/stack";
import React from 'react';
import { CalendarStackParamList } from "../types";
import { Platform, View } from 'react-native';
import CalendarScreen from "../screens/MidLevel/CalendarScreen/CalendarScreen";
import CalendarEvent from "../screens/MidLevel/CalendarScreen/CalendarEvent";
import Meetings from "../screens/MidLevel/CalendarScreen/Meetings";
import CalendarMenu from "../screens/MidLevel/CalendarScreen/screens/CalendarMenu";
import MeetingPage from "@navigation/screens/MidLevel/CalendarScreen/screens/MeetingPage";
import RemindersScreen from "../screens/MidLevel/RemindersScreen";
import BreakdownScreen from "../screens/MidLevel/CalendarScreen/screens/BreakdownScreen";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";
import { CalendarHeader } from "./CalendarHeader";

const CalendarStack = Platform.OS === 'web'
  ? createStackNavigator<CalendarStackParamList>()
  : createNativeStackNavigator<CalendarStackParamList>();

const CalendarStackNavigator = () => {
  const theme = themeSelector();

  return (
    <View style={{ flex: 1 }}>
      <CalendarStack.Navigator screenOptions={{
        headerShown: false,
        cardStyle: { backgroundColor: theme ? "white" : "black" }
      }}>
          <CalendarStack.Screen
            name="MainCalendar"
            component={CalendarScreen}
          options={{
            title: 'Main Calendar',
            freezeOnBlur: true,
            headerShown: Platform.OS === 'web',
            header() {
              if (Platform.OS === 'web') {
                return <CalendarHeader />;
              }
              return null;
            },
          }}
        />
        <CalendarStack.Screen
          name="CalendarMenu"
          component={CalendarMenu}
          options={{
            title: 'Calendar Menu',
            headerShown: false
          }}
        />
        <CalendarStack.Screen
          name="MeetingPage"
          component={MeetingPage}
          options={{ headerShown: false }}
        />
        <CalendarStack.Screen
          name='CalendarEvent'
          component={CalendarEvent}
          options={{
            title: 'Calendar Event',
            headerShown: false
          }}
        />
        <CalendarStack.Screen
          name="Meetings"
          component={Meetings}
          options={{
            title: 'Meetings',
            headerShown: false
          }}
        />
        <CalendarStack.Screen
          name="Reminders"
          component={RemindersScreen}
          options={{
            title: 'Reminders',
            headerShown: false
          }}
        />
        <CalendarStack.Screen
          name="Breakdown"
          component={BreakdownScreen}
          options={{
            title: 'Breakdown',
            headerShown: false
          }}
        />
      </CalendarStack.Navigator>
    </View >
  )
}
export { CalendarStack, CalendarStackNavigator }